import { Injectable } from "@angular/core";

const TOKEN_KEY = "AuthToken";
const role = "role";
const entityName = "entityName";
const apimange_key = "apiMange";
const ApiMappingattribute = "apiMappingAttribute";
const ApiData = "apiData";
const apiMappingData = "apiMappingData";
const apiResponse = "apiResponse";
const analyticsformId = "analyticsformId";
const apiMappingId = "apiMappingId";
const group = "group";
const apiParentId = "apiParentId";
const apiGroupId = "apiGroupId";
const apiManagerId = "apiManagerId";
const responseMappingId = "responseMapppingId";
const ApiId = "ApiId";
const ApiResultId = "ApiResultId";
const SelectedEntity = "SelectedEntity";
const infoHighlighted = "infoHighlighted";
const pageIndex = "pageIndex";
const pageSize = "pageSize";
const pageLength = "pageLength";
const theme = "theme";

@Injectable({
  providedIn: "root",
})
export class LstorageService {
  constructor() {}

  public clear() {
    window.sessionStorage.removeItem(apimange_key);
    window.sessionStorage.removeItem(ApiMappingattribute);
    window.sessionStorage.removeItem(ApiData);
    window.sessionStorage.removeItem(apiMappingData);
    window.sessionStorage.removeItem(apiMappingId);
    window.sessionStorage.removeItem(apiManagerId);
    // window.sessionStorage.clear();
  }

  public saveToken(token: string, userrole: string) {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.removeItem(role);

    window.sessionStorage.setItem(TOKEN_KEY, token);
    window.sessionStorage.setItem(role, userrole);
  }

  public getToken(): string {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  logOut() {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.removeItem(role);
    window.sessionStorage.clear();
  }

  public saveEntityName(name: string) {
    window.sessionStorage.setItem(entityName, JSON.stringify(name));
  }

  public getEntityName(): string {
    var retrievedObject = sessionStorage.getItem(entityName);
    return JSON.parse(retrievedObject);
  }

  clearanalyticsformId() {
    window.sessionStorage.removeItem(analyticsformId);
  }

  public clearResponseMappingId() {
    window.sessionStorage.removeItem(responseMappingId);
  }

  public getRole(): string {
    return sessionStorage.getItem(role);
  }

  public saveInfoHighlights(apiData: string) {
    window.sessionStorage.setItem(infoHighlighted, JSON.stringify(apiData));
  }

  public getInfoHighlights(): string {
    var info = sessionStorage.getItem(infoHighlighted);
    return JSON.parse(info);
  }

  public saveApiStaticData(apiData: string) {
    window.sessionStorage.setItem(apimange_key, JSON.stringify(apiData));
  }

  public getApiStaticData(): string {
    var retrievedObject = sessionStorage.getItem(apimange_key);
    return JSON.parse(retrievedObject);
  }

  public saveApiDyanamicAttribute(apiData: string) {
    window.sessionStorage.setItem(ApiMappingattribute, JSON.stringify(apiData));
  }

  public getApiDyanamicAttribute(): string {
    var retrievedObject = sessionStorage.getItem(ApiMappingattribute);
    return JSON.parse(retrievedObject);
  }

  public saveApiData(apiData: any) {
    window.sessionStorage.setItem(ApiData, JSON.stringify(apiData));
  }

  public getApiData(): string {
    var retrievedObject = sessionStorage.getItem(ApiData);
    return JSON.parse(retrievedObject);
  }

  public saveApiId(apiId: string) {
    window.sessionStorage.setItem(ApiId, JSON.stringify(apiId));
  }
  // public saveApiId(Id: any) {
  //   window.sessionStorage.setItem(ApiId, Id);
  // }

  public getApiId(): string {
    var retrievedObject = sessionStorage.getItem(ApiId);
    return JSON.parse(retrievedObject);
  }

  public saveApiResultId(resultId: string) {
    window.sessionStorage.setItem(ApiResultId, JSON.stringify(resultId));
  }

  public getApiResultId(): string {
    var retrievedObject = sessionStorage.getItem(ApiResultId);
    return JSON.parse(retrievedObject);
  }

  public saveApiResponse(apiRes: string) {
    window.sessionStorage.setItem(apiResponse, JSON.stringify(apiRes));
  }

  public getApiResponse(): string {
    var retrievedObject = sessionStorage.getItem(apiResponse);
    return JSON.parse(retrievedObject);
  }

  public saveApiMappingData(apiData: string) {
    window.sessionStorage.setItem(apiMappingData, JSON.stringify(apiData));
  }

  public getApiMappingData(): string {
    var retrievedObject = sessionStorage.getItem(apiMappingData);
    return JSON.parse(retrievedObject);
  }

  public saveApiMappingId(apiData: string) {
    window.sessionStorage.setItem(apiMappingId, JSON.stringify(apiData));
  }

  public getApiMappingId(): string {
    var retrievedObject = sessionStorage.getItem(apiMappingId);
    return JSON.parse(retrievedObject);
  }

  public saveResponseMappingId(responseMapping: string) {
    window.sessionStorage.setItem(
      responseMappingId,
      JSON.stringify(responseMapping)
    );
  }

  public getResponseMappingId(): string {
    var retrievedObject = sessionStorage.getItem(responseMappingId);
    return JSON.parse(retrievedObject);
  }

  public saveGroupId(apiData: string) {
    window.sessionStorage.setItem(group, JSON.stringify(apiData));
  }

  public getGroupId(): string {
    var retrievedObject = sessionStorage.getItem(group);
    return JSON.parse(retrievedObject);
  }

  public saveParentId(apiData: string) {
    window.sessionStorage.setItem(apiParentId, JSON.stringify(apiData));
  }

  public getParentId(): string {
    var retrievedObject = sessionStorage.getItem(apiParentId);
    return JSON.parse(retrievedObject);
  }

  public saveSelectedEntity(entity: any) {
    window.sessionStorage.setItem(SelectedEntity, JSON.stringify(entity));
  }

  public getSelectedEntity(): string {
    var EntityList = sessionStorage.getItem(SelectedEntity);
    //  alert(EntityList);
    return JSON.parse(EntityList);
  }

  public apiGroupclear() {
    window.sessionStorage.removeItem(apiParentId);
    window.sessionStorage.removeItem(group);
    window.sessionStorage.removeItem(apiManagerId);
  }

  public saveApiGroupId(apiData: string) {
    window.sessionStorage.setItem(apiGroupId, JSON.stringify(apiData));
  }

  public getApiGroupId(): string {
    var retrievedObject = sessionStorage.getItem(apiGroupId);
    return JSON.parse(retrievedObject);
  }

  public saveApiManagerId(apiData: string) {
    window.sessionStorage.setItem(apiManagerId, JSON.stringify(apiData));
  }

  public getApiManagerId(): string {
    var retrievedObject = sessionStorage.getItem(apiManagerId);
    return JSON.parse(retrievedObject);
  }

  public saveAnalyticsFormId(apiRes: string) {
    window.sessionStorage.setItem(analyticsformId, JSON.stringify(apiRes));
  }

  public getAnalyticeFormId(): string {
    var retrievedObject = sessionStorage.getItem(analyticsformId);
    return JSON.parse(retrievedObject);
  }

  //Api Group Pagination
  public savepageIndex(apiRes: string) {
    window.sessionStorage.setItem(pageIndex, JSON.stringify(apiRes));
  }

  public getpageIndex(): string {
    var retrievedObject = sessionStorage.getItem(pageIndex);
    return JSON.parse(retrievedObject);
  }

  public savepageSize(apiRes: string) {
    window.sessionStorage.setItem(pageSize, JSON.stringify(apiRes));
  }

  public getpageSize(): string {
    var retrievedObject = sessionStorage.getItem(pageSize);
    return JSON.parse(retrievedObject);
  }

  public savepagelength(apiRes: string) {
    window.sessionStorage.setItem(pageLength, JSON.stringify(apiRes));
  }

  public getpagelength(): string {
    var retrievedObject = sessionStorage.getItem(pageLength);
    return JSON.parse(retrievedObject);
  }
  //

  public saveTheme(themeType: any) {
    window.sessionStorage.setItem(theme, JSON.stringify(themeType));
  }

  public getTheme(): any {
    var retrievedObject = sessionStorage.getItem(theme);
    return JSON.parse(retrievedObject);
  }
}
